import { render, staticRenderFns } from "./TableColumnPreference.vue?vue&type=template&id=32646dc8&"
import script from "./TableColumnPreference.vue?vue&type=script&lang=js&"
export * from "./TableColumnPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports